module.exports = __webpack_public_path__ + "static/img/我要打印-banner.04a4168.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/我要打印/我要打印-banner.jpg
// module id = EBcV
// module chunks = 1